export const DEFAULT = 'default' as const;
export const LINES = 'lines' as const;
export const COUNT = 'count' as const;

export const DEPENDENCY_SETTINGS = {
	DEFAULT,
	LINES,
	COUNT,
} as const;
